import { render } from "./work-organisation.vue?vue&type=template&id=f0e3c204&scoped=true"
import script from "./work-organisation.vue?vue&type=script&lang=js"
export * from "./work-organisation.vue?vue&type=script&lang=js"

import "./work-organisation.vue?vue&type=style&index=0&id=f0e3c204&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0e3c204"],['__file',"src/components/applications/workorganisation/work-organisation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f0e3c204"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f0e3c204', __exports__)) {
    api.reload('f0e3c204', __exports__)
  }
  
  module.hot.accept("./work-organisation.vue?vue&type=template&id=f0e3c204&scoped=true", () => {
    api.rerender('f0e3c204', render)
  })

}


export default __exports__